import { jsx as _jsx } from "react/jsx-runtime";
import { useLoader } from '../context/LoaderContext';
import { useCheckToolsVisibility } from '../hooks/useCheckToolsVisibility';
const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ' rgba(255, 255, 255, 0.25)',
        flexDirection: 'column',
        userSelect: 'none',
        width: '100%',
        height: '100%',
        outline: '10px dashed rgba(0, 0, 0, 0.3)',
        outlineOffset: '-10px',
        paddingLeft: '20px',
        paddingRight: '20px',
    },
    text: {
        padding: '15px 30px',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        borderRadius: '39px',
        color: 'white',
        fontSize: 'x-large',
        fontWeight: 'bold',
    },
};
function NoData({ isEmpty = true, emptyText = 'Drag and drop here a JCAMP-DX, Bruker folder, Jeol jdf or NMRium file', canOpenLoader = true, style, }) {
    const openLoader = useLoader();
    const isToolEnabled = useCheckToolsVisibility();
    if (!isEmpty) {
        return null;
    }
    return (_jsx("div", { style: { ...styles.container, ...style }, ...(canOpenLoader && { onClick: openLoader }), children: _jsx("p", { style: styles.text, children: isToolEnabled('import')
                ? emptyText
                : 'Importation feature has been disabled' }) }));
}
export default NoData;
